import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import AnnotationTypeSelector from './components/AnnotationTypeSelector';
import QualityIssueContainer from './QualityIssueContainer';
import SuggestionContainer from './SuggestionContainer';
import { ANNOTATION_TYPES } from '../../constants';
import './AnnotatorApp.css';


class AnnotatorApp extends React.Component {
  static createTextSelection() {
    const highlightedText = window.getSelection();
    const range = highlightedText.getRangeAt(0);
    const selectionSpan = document.createElement('span');
    selectionSpan.classList.add('text-selection');
    // On text selection it is possible that annotation DOM elements gets copied.
    // In this case we will loose jquery attached data from annotation library.
    // So we need to make sure these data gets copied.
    const annotations = AnnotatorApp.readAnnotationData(range);
    selectionSpan.appendChild(range.extractContents());
    range.insertNode(selectionSpan);
    // re/assign annotations via jquery data()
    AnnotatorApp.applyAnnotationData(range, annotations);
  }

  static readAnnotationData(range) {
    const annotations = new Map();
    let id = 0;
    const nodes = range.cloneContents().children;
    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];
      if (node.dataset && node.dataset.annotationId) {
        id = node.dataset.annotationId;
        annotations.set(id, $(`span[data-annotation-id="${id}"]`).data('annotation'));
      }
    }
    return annotations;
  }

  static applyAnnotationData(range, annotations) {
    /* eslint-disable no-param-reassign */
    annotations.forEach((annotation, id) => {
      const elements = $(range.startContainer).find(`span[data-annotation-id="${id}"]`);
      annotation._local.highlights = elements;
      elements.data('annotation', annotation);
    });
  }

  static removeTextSelection() {
    const selections = document.querySelectorAll('#content .text-selection');
    for (let i = 0; i < selections.length; i += 1) {
      const selection = selections[i];
      selection.replaceWith(...selection.childNodes);
    }
  }

  static removeWindowSelection() {
    if (!window.getSelection) {
      return;
    }

    // Chrome
    if (window.getSelection().empty) {
      window.getSelection().empty();
      return;
    }

    // Firefox
    if (window.getSelection().removeAllRanges) {
      window.getSelection().removeAllRanges();
      return;
    }

    // IE
    if (document.selection) {
      document.selection.empty();
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      type: props.type,
      isNew: typeof props.annotation.id === 'undefined',
    };

    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.setType = this.setType.bind(this);
    this.closeEditorOnClickOutside = this.closeEditorOnClickOutside.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('mousedown', this.closeEditorOnClickOutside);
  }

  async componentDidUpdate(_, prevState) {
    const { type } = this.props;
    if (prevState.type !== type) {
      await this.setType(type);
    }
  }

  onClose() {
    const { onClose } = this.props;
    document.removeEventListener('mousedown', this.closeEditorOnClickOutside);
    AnnotatorApp.removeTextSelection();
    AnnotatorApp.removeWindowSelection();
    onClose();
  }

  async onSubmit(annotation) {
    const { onAnnotationCreate, onAnnotationUpdate } = this.props;
    const { type, isNew } = this.state;
    if (isNew) {
      await onAnnotationCreate(annotation, type);
    } else {
      await onAnnotationUpdate(annotation, type);
    }
    this.onClose();
  }

  setType(type) {
    this.setState({ type });
  }

  closeEditorOnClickOutside(event) {
    const modals = document.querySelectorAll('.annotator-outer');
    for (let i = 0; i < modals.length; i += 1) {
      if (modals[i].contains(event.target)) {
        return;
      }
    }
    this.onClose();
  }

  render() {
    const { gocheckVersion, annotation } = this.props;
    const { type } = this.state;

    switch (type) {
      case ANNOTATION_TYPES.issue:
        return (
          <QualityIssueContainer
            gocheckVersion={gocheckVersion}
            annotation={annotation}
            onSubmit={this.onSubmit}
            onClose={this.onClose}
          />
        );
      case ANNOTATION_TYPES.suggestion:
        return (
          <SuggestionContainer
            annotation={annotation}
            onSubmit={this.onSubmit}
            onClose={this.onClose}
          />
        );
      default:
        AnnotatorApp.createTextSelection();
        return (
          <AnnotationTypeSelector
            onClose={this.onClose}
            onChange={this.setType}
          />
        );
    }
  }
}


AnnotatorApp.propTypes = {
  gocheckVersion: PropTypes.string.isRequired,
  annotation: PropTypes.shape({
    id: PropTypes.number,
    errorType: PropTypes.string,
    severity: PropTypes.string,
    comment: PropTypes.string,
  }).isRequired,
  onAnnotationCreate: PropTypes.func.isRequired,
  onAnnotationUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string,
};


AnnotatorApp.defaultProps = {
  type: null,
};


export default AnnotatorApp;
